import { Trans, useTranslation } from 'react-i18next'
import { Link as DomLink } from 'react-router-dom'
import { ParcelTapeIllustration } from '@dhl-ui/illustrations'
import { Link } from '@dhl-ui/components'
import { links } from '~/AppRoutes'
import { NotAvailablePage } from '~/modules/navigation/views/NotAvailablePage'

export const NotAllowedPage = () => {
  const { t } = useTranslation()

  const linkToDashboard = <Link component={DomLink} key={0} href={links.dashboardLink()} title="go to dashboard" />
  return (
    <NotAvailablePage
      title={t('admin.navigation.notAllowed.title')}
      Image={ParcelTapeIllustration}
      dataTest="route-not-allowed"
    >
      <Trans i18nKey="admin.navigation.notAllowed.description" components={{ linkToDashboard }} />
    </NotAvailablePage>
  )
}
